import { TextField, Button, styled } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    fontSize: 15,
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  fontWeight: 600,
  fontSize: 15,
  textTransform: 'none',
}));